// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__JeVjZ","inner":"Footer_inner__1NTV3"};